/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_forgot_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Nebyl nalezen žádný účet s touto e-mailovou adresou.`
};

const da_account_forgot_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Ingen konto fundet med denne email.`
};

const de_account_forgot_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Kein Konto mit dieser E-Mail-Adresse gefunden.`
};

const en_account_forgot_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `No account found with this email address.`
};

const es_account_forgot_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `No se encontró ninguna cuenta con este correo.`
};

const fr_account_forgot_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Aucun compte trouvé avec cette adresse email.`
};

const hu_account_forgot_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Nem található fiók ehhez az e-mail címhez.`
};

const it_account_forgot_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Nessun account trovato con questa email.`
};

const nl_account_forgot_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Geen account gevonden met dit e-mailadres.`
};

const pl_account_forgot_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Nie znaleziono konta z tym adresem e-mail.`
};

const pt_account_forgot_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Nenhuma conta encontrada com este e-mail.`
};

const sv_account_forgot_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Inget konto hittades med denna e-postadress.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_forgot_password_errors_404 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_forgot_password_errors_404(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_forgot_password_errors_404", locale)
	if (locale === "cs") return cs_account_forgot_password_errors_404(inputs)
	if (locale === "da") return da_account_forgot_password_errors_404(inputs)
	if (locale === "de") return de_account_forgot_password_errors_404(inputs)
	if (locale === "en") return en_account_forgot_password_errors_404(inputs)
	if (locale === "es") return es_account_forgot_password_errors_404(inputs)
	if (locale === "fr") return fr_account_forgot_password_errors_404(inputs)
	if (locale === "hu") return hu_account_forgot_password_errors_404(inputs)
	if (locale === "it") return it_account_forgot_password_errors_404(inputs)
	if (locale === "nl") return nl_account_forgot_password_errors_404(inputs)
	if (locale === "pl") return pl_account_forgot_password_errors_404(inputs)
	if (locale === "pt") return pt_account_forgot_password_errors_404(inputs)
	return sv_account_forgot_password_errors_404(inputs)
};
export { account_forgot_password_errors_404 as "account.forgot_password_errors.404" }